import React, { useState, forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { ListItem, Button, Collapse } from '@mui/material';


const CustomRouterLink = forwardRef(function CustomLink(props, ref) {
  return (
    <div ref={ref} style={{ flexGrow: 1 }}>
      <RouterLink {...props} />
    </div>
  );
});

const SidebarMenuListItem = props => {
  const {
    title,
    href,
    depth,
    children,
    icon: Icon,
    className,
    open: openProp,
    label: Label,
    ...rest
  } = props;

  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen(open => !open);
  };

  let paddingLeft = 22;

  if (depth > 0) {
    paddingLeft = 16 + 20 * depth;
  }
  const style = {
    paddingLeft
  };
  const currentPath = window.location.pathname;

  if (children) {
    const isParentActive = href ? currentPath === href : false;
    return (
      <ListItem
        {...rest}
        className={clsx('app-sidebar-item', className)}
        disableGutters>
        <Button
          color="primary"
          className={clsx('app-sidebar-button', { active: isParentActive })}
          // onClick={handleToggle}
          style={style} >
          {/* {Icon && <Icon className="app-sidebar-icon" />}&nbsp;&nbsp;
          <span>{title}</span> */}
          <span style={{ display: 'flex', alignItems: 'center', marginLeft: 0, marginRight: 8 }}>
            {/* {open ? (
              <KeyboardArrowDownIcon className="sidebar-expand-icon" color="inherit" />
            ) : (
              <KeyboardArrowLeftIcon
                className="sidebar-expand-icon sidebar-expand-icon-rotate"
                color="inherit"
              />
            )} */}
          </span>
          {/* </span> */}
          {Icon && <Icon className="app-sidebar-icon" />}
          <span>{title}</span>
        </Button>
        <Collapse in={open}>
          <div style={{ paddingLeft: 16 }}>{children}</div>
        </Collapse>
      </ListItem>
    );
  } else {
    return (
      <ListItem
        {...rest}
        className={clsx('app-sidebar-item', className)}
        disableGutters>
        <Button
          // activeClassName="active-item"
          color="primary"
          disableRipple
          variant="text"
          className={clsx('app-sidebar-button-wrapper', `depth-${depth}`)}
          component={CustomRouterLink}
          //exact
          style={style}
          to={href}>
          {Icon && <Icon className="app-sidebar-icon" />}&nbsp;&nbsp;
          {title}
          {Label && (
            <span className="menu-item-label">
              <Label />
            </span>
          )}
        </Button>
      </ListItem>
    );
  }
};

SidebarMenuListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.any,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};

SidebarMenuListItem.defaultProps = {
  depth: 0,
  open: true
};

export default SidebarMenuListItem;
